import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp from 'components/StyledComp';
import DataTables from 'components-desktop/DataTables';

const propTypes = {
  title: PropTypes.string,
  authorizations: PropTypes.array,
};

const defaultProps = {
  title: '',
  authorizations: [],
};

@autobind
class TableExpiringAuths extends BaseComponent {
  constructor(props) {
    super(props);
  }

  createColumns() {
    return [{
      title: 'Company Name',
      dataIndex: 'companyName',
      sorter: (a, b) => a.companyName?.localeCompare(b.companyName),
    }, {
      title: 'Patient Name',
      dataIndex: 'patientName',
      sorter: (a, b) => a.patientName?.localeCompare(b.patientName),
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={`/patients/patient_profile?id=${record.patientId}`}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'Authorization Code',
      dataIndex: 'code',
      sorter: (a, b) => a.code?.localeCompare(b.code),
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={`/patients/patient_profile?id=${record.patientId}#authorizations`}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'Service Start Date',
      dataIndex: 'serviceStartDateUsString',
      sorter: (a, b) => a.serviceStartDate - b.serviceStartDate,
    }, {
      title: 'Service End Date',
      dataIndex: 'serviceEndDateUsString',
      sorter: (a, b) => a.serviceEndDate - b.serviceEndDate,
      render: (text, record) => (
        <styledComp.Span
          width="wrap_content"
          height="wrap_content"
          color={record.serviceEndDate < Date.now() ? '#f00' : '#ffa500'}
          fontSize="14px"
        >
          {text}
        </styledComp.Span>
      ),
      defaultSortOrder: 'ascend',
    }, {
      title: 'Service Code',
      dataIndex: 'serviceCode',
      sorter: (a, b) => a.serviceCode?.localeCompare(b.serviceCode),
    }, {
      title: 'Remark',
      dataIndex: 'remark',
      sorter: (a, b) => a.remark?.localeCompare(b.remark),
      render: (text, record) => (
        <Tooltip title={text}>
          <styledComp.Span
            width="wrap_content"
            height="wrap_content"
            maxWidth="150px"
            color="textPrimaryDark"
            fontSize="14px"
            ellipsis
            display="inline-block"
          >
            {text}
          </styledComp.Span>
        </Tooltip>
      ),
    }];
  }

  createDataSource(authorizations) {
    const dataSource = [];
    authorizations.forEach((authorization, index) => {
      dataSource.push({
        key: authorization.getId(),
        id: authorization.getId(),
        companyName: authorization.getString('companyName'),
        patientId: authorization.getLong('patientId'),
        patientName: authorization.getString('patientName'),
        code: authorization.getString('code'),
        serviceStartDate: authorization.getLong('serviceStartDate'),
        serviceStartDateUsString: authorization.getString('serviceStartDateUsString'),
        serviceEndDate: authorization.getLong('serviceEndDate'),
        serviceEndDateUsString: authorization.getString('serviceEndDateUsString'),
        serviceCode: authorization.getRemoteObject('service')?.getString('displayCode'),
        remark: authorization.getString('remark'),
      });
    });
    return dataSource;
  }

  renderContent() {
    const { authorizations, title, ...layoutProps } = this.props;

    return (
      <DataTables
        {...layoutProps}
        ref={(ref) => { this.dataTables = ref; }}
        color="blue_hoki"
        fontSize="14px"
        size="small"
        title={title}
        icon="file-pdf"
        withColumnFilter={false}
        columns={this.createColumns()}
        dataSource={this.createDataSource(authorizations)}
      />
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
TableExpiringAuths.propTypes = propTypes;
TableExpiringAuths.defaultProps = defaultProps;

export default TableExpiringAuths;
